import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef, MatTableDataSource } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { EbayService } from '../_shemistshopservices/ebay.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { DatePipe } from '@angular/common';
import { GrouponService } from '../_shemistshopservices/groupon.service';

@Component({
  selector: 'app-groupon-order-details',
  templateUrl: './groupon-order-details.component.html',
  styleUrls: ['./groupon-order-details.component.css']
})
export class GrouponOrderDetailsComponent implements OnInit {

  order_id: string | null = null;
  orderStatusList: any = [];
  orderItems: any = [];

  orderData:any = null;

  emailContent: string = null;
  smsContent: string = null;


  statusForm : FormGroup = new FormGroup({
    id: new FormControl(null),
    order_status_id: new FormControl(''),
  });
    
  constructor(
    private dialog: MatDialog,
    private loading : LoadingService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private grouponService: GrouponService,
    private titleService: Title) { }
  
  
  ngOnInit() {
    this.titleService.setTitle('Order Details');
    this.route.paramMap.subscribe(params => {
      this.order_id = params.get('id'); // Access the route parameter
      this.fetchOrderData();
    });
  }
  

  onSubmitStatusForm(){
    //console.log(this.claimService.claimStatusForm.value);
    if(this.statusForm.valid)
      {
        //this.loading.spin$.next(true);
        var result = this.grouponService.update_groupon_status(this.order_id, this.statusForm.value).subscribe(data=> {
          console.log(data);
          if(JSON.stringify(data['status'])=='true') {
            this.notificationService.success(data['message']);          
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(JSON.stringify(data['error_message']));
            this.loading.spin$.next(false);
          }        
        });
      }
  }

  fetchOrderData(){
    var result = this.grouponService.get_order_by_id(this.order_id).subscribe(data=> {
      console.log(data['data']);
      this.orderData = data['order_data'];
      this.orderStatusList = data['groupon_order_status_list'];
      console.log(this.orderStatusList);

      const formData = {
        id: this.orderData.id,
        order_status_id: this.orderData.order_status_id,
      };

      console.log(formData);
      this.statusForm.setValue(formData);

    });
  }

  onShowEmailContent(ob)
  {
    var data = this.orderStatusList.filter(x => x.id === ob.value);
    if(data.length>0)
    {
      this.emailContent = data[0]['email_template'];
      this.smsContent = data[0]['sms_template'];
      //console.log(this.emailContent);
    }
    else
    {
      this.emailContent = null;
    }
  }

  onViewQA(order_item_id) {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "80%";    
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { order_item_id: order_item_id };
    this.dialog.open(ViewGrouponQADialog, matDialogConfig);
  }




}


@Component({
  selector: 'view-qa-dialog',
  templateUrl: 'view-qa-dialog.html',
})
export class ViewGrouponQADialog {

  order_item_id: any = null;
  qa_data: any = null;

  constructor(
    public datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data,
    private loading : LoadingService,
    private grouponService: GrouponService,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<GrouponOrderDetailsComponent>) {
      this.order_item_id = data.order_item_id;
  }

  ngOnInit() {
    this.onLoadData();
  }

  onLoadData(){
    console.log(this.order_item_id);
    var result = this.grouponService.groupon_get_questionnaire(this.order_item_id).subscribe(data=> {
      console.log(data['qa_data']);
      this.qa_data = data['qa_data'];
    });
  }

  onClose() {
    this.dialogRef.close();
  }


}

